import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import App from "./pages/App";
import Welcome from "./pages/Welcome";

// routes
const routing = (
  <>
    <React.StrictMode>
      <Router>
        <Switch>
          <Route path="/" exact component={Welcome} />
          <Route path="/app" exact component={App} />
        </Switch>
      </Router>
    </React.StrictMode>
  </>
);

ReactDOM.render(routing, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
